import React from 'react';
import {
    Route,
    Redirect
  } from 'react-router-dom';
import AuthService from "../services/AuthService";


export default function PrivateRoute ({ component: Component, data, ...rest }) {
    return (
    <Route {...rest} render={(props) => (
      AuthService.isTokenValid()
        ? <Component {...rest} {...props} {...data} />
        : <Redirect to='/login' />
    )} />
  )}